import { useEffect, useState } from 'react';
import { useApi } from '../../../utils/hooks';
import { IMembershipTypeLookupDto } from '../../../utils/constants/interfaces';

// Hook to fetch membership types from the API
const useMembershipTypeLookup = () => {
  const api = useApi();
  const [membershipTypes, setMembershipTypes] = useState<IMembershipTypeLookupDto[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadMembershipTypes = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.get<IMembershipTypeLookupDto[]>('/membership-types/lookup');
        if (response?.isSuccessStatusCode && response.response) {
          setMembershipTypes(response.response);
        } else {
          setError('Failed to load membership types');
          setMembershipTypes([]);
        }
      } catch (err) {
        setError('Error loading membership types');
        setMembershipTypes([]);
      } finally {
        setLoading(false);
      }
    };

    void loadMembershipTypes();
  }, [api]);

  return {
    membershipTypes,
    loading,
    error
  };
};

export default useMembershipTypeLookup;
